import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostListener, Input, Output, NgZone, inject } from '@angular/core'

@Component({
  selector: 'hyperkit-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class DropdownMenuComponent {
  private elementRef = inject(ElementRef);
  private ngZone = inject(NgZone);

  @Input() isVisible = false
  @Output() closed = new EventEmitter<void>()
  @Input() position: 'relative' | 'absolute' = 'relative'

  // Flag to track if the dropdown was just opened
  private justOpened = false

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    // If the dropdown was just made visible, don't process this click event
    if (this.justOpened) {
      this.justOpened = false
      return
    }

    // Close if clicked outside
    if (
      this.isVisible &&
      !this.elementRef.nativeElement.contains(event.target)
    ) {
      this.isVisible = false
      this.closed.emit()
    }
  }

  @HostListener('keydown.escape')
  onEscapeKey() {
    if (this.isVisible) {
      this.isVisible = false
      this.closed.emit()
    }
  }

  // Watch for changes to isVisible
  ngOnChanges() {
    // If the dropdown is being opened
    if (this.isVisible) {
      // Set the justOpened flag
      this.justOpened = true

      // Clear the flag after the current event cycle completes
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          this.justOpened = false
        }, 0)
      })
    }
  }
}
